export default __webpack_public_path__ + "static/rock-star-5f6f34e002c2fb206e3f4974c1428b69.png";